import React, { useCallback, useRef } from "react";
import classnames from "classnames";

import { useIsSticky } from "shared/hooks";
import { useColumnTemplate } from "shared/hooks/use-column-template";
import { ProductHeader } from "./product-header";
import { UUID_DEFINITIONS } from "../lib/constants";
import { format } from "date-fns";
import { DATE_FNS_LONG_DATE_FORMAT } from "../../../shared/constants";

export const ProductCompareHeader = ({ references, columnWidths, onColumnWidthChange, productMatches, openModal, onMatchSelection }) => {
    const refCompareWrapper = useRef();
    const isSticky = useIsSticky(refCompareWrapper);
    const { gridTemplateColumns } = useColumnTemplate(references.length + productMatches.length + 1, columnWidths, true, true);

    const getProductStatus = useCallback((reference) => {
        return reference.isFinalized ? `Completed - ${format(new Date(reference.publishDate), DATE_FNS_LONG_DATE_FORMAT)}` : "WIP";
    }, []);

    return (
        <>
            <div ref={refCompareWrapper} />
            <div className={classnames("product-compare fit-content", { "-sticky": isSticky })}>
                <div
                    className="product-compare-header p-b-10"
                    style={{ gridTemplateColumns }}
                >
                    <div className="-no-padding justify-start">
                        <div className="dark-inner empty"></div>
                        <div className="p-10">
                            <div className="txt-left txt-normal">Images</div>
                        </div>
                    </div>
                    {references.map((reference, index) => {
                        const productName = reference.attributes[UUID_DEFINITIONS.itemName];

                        return (
                            <ProductHeader
                                key={reference.codingWipKey}
                                reference
                                product={reference}
                                name={productName}
                                description={getProductStatus(reference)}
                                col={index + 2}
                                onColumnWidthChange={onColumnWidthChange}
                                openModal={openModal}
                                onMatchSelection={onMatchSelection}
                            />
                        );
                    })}
                    {productMatches.map((product, index) => {
                        const productName = product.attributes[UUID_DEFINITIONS.itemName];

                        return (
                            <ProductHeader
                                key={product.codingWipKey}
                                product={product}
                                name={productName}
                                description={getProductStatus(product)}
                                col={index + 2}
                                onColumnWidthChange={onColumnWidthChange}
                                openModal={openModal}
                                onMatchSelection={onMatchSelection}
                            />
                        );
                    })}
                </div>
            </div>
        </>
    );
};
